export const resultLimit = 20;
export const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/i;
export const mobileRegex = /^([6789]\d{9})$/;
export const placeofbirthRegex = /^[a-zA-Z0-9]+$/;
const env = process.env.REACT_APP_ENV ? process.env.REACT_APP_ENV : 'local-env';
const [firstPrefix, secondPrefix] = env.split('-');
export const TOKEN_KEY = `${firstPrefix}-${secondPrefix}_token`;
export const TENANT_NAME_MAPPING = {
  'lgtindia-online': 'lgtindia',
};

// Orgs restricted from self-serve signup; must onboard investors via Urban Money Force instead.
export const RESTRICTED_SIGNUP_TENANTS = ['urbanmoney', 'elevo'];
export const SIGNUP_RESTRICTED_MESSAGE =
  'Please use the Urban Money Force/Partner app for investor onboarding.';
